import { client } from '../../../../../common-utils/libraries/axios/axios';
import SESSION from '../apiUrls';

/**
 * @param responseData response.data object
 * @param responseData.MfaUri string
 *
 * @returns Mapped data object
 */
function mapResponseData({ MfaUri }) {
    const data = {};

    data.MfaUri = MfaUri;

    return data;
}

const queryGetQrcodeUri = () => {
    return {
        queryKey: [SESSION.FETCH_QRCODE_URI.queryKey],
        queryFn: async () => {
            const response = await client.get(SESSION.FETCH_QRCODE_URI.url);
            return mapResponseData(response.data);
        }
    };
};

export default queryGetQrcodeUri;